<template>
  <div>
    <promo-code-form :is-new="false" />
  </div>
</template>

<script>
import PromoCodeForm from '../components/PromoCodeForm.vue'

export default {
  components: {
    PromoCodeForm,
  },
}
</script>

<style>

</style>
